type Bucket = [string, number];

export const sortBuckets = (buckets: Bucket[], isAsc = true): Bucket[] => {
  const getFirstNumber = (bucketString: string): number => parseInt(bucketString.split(' ')[0], 10);
  return buckets.toSorted((a, b) => {
    const firstBucket = isAsc ? a[0] : b[0];
    const secondBucket = isAsc ? b[0] : a[0];

    const isFirstOther = firstBucket === 'Other';
    const isSecondOther = secondBucket === 'Other';

    if (isFirstOther) {
      return isAsc ? 1 : -1;
    }
    if (isSecondOther) {
      return isAsc ? -1 : 1;
    }

    const numA = getFirstNumber(firstBucket);
    const numB = getFirstNumber(secondBucket);

    if (Number.isNaN(numA) || Number.isNaN(numB)) {
      return 0;
    }

    return numA - numB;
  });
};
